import script from "./customButtonV2.vue?vue&type=script&setup=true&lang=js"
export * from "./customButtonV2.vue?vue&type=script&setup=true&lang=js"

import "./customButtonV2.vue?vue&type=style&index=0&id=2be30bbf&lang=scss&scoped=true"

import exportComponent from "/home/steffen/Projekte/clubadmin/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be30bbf"]])

export default __exports__